(() => {
  const tick = () => {
    document.querySelectorAll('[data-wsp-gift-countdown]').forEach((timer) => {
      const end = new Date(timer.dataset.end).getTime();
      const remaining = Math.max(0, end - Date.now());
      const feature = timer.closest('[data-wsp-gift-expiring-feature]');
      if (feature) feature.hidden = remaining === 0;
      const units = {
        days: Math.floor(remaining / 86400000),
        hours: Math.floor((remaining % 86400000) / 3600000),
        minutes: Math.floor((remaining % 3600000) / 60000),
        seconds: Math.floor((remaining % 60000) / 1000)
      };
      Object.entries(units).forEach(([key, value]) => {
        const node = timer.querySelector('[data-' + key + ']');
        if (node) node.textContent = String(value).padStart(2, '0');
      });
      const time = timer.querySelector('.wsp2-giftcountdown__time');
      const ended = timer.querySelector('.wsp2-giftcountdown__ended');
      if (time) time.hidden = remaining === 0;
      if (ended) ended.hidden = remaining !== 0;
    });
  };
  window.wspGiftCountdownTick = tick;
  tick();
  if (!window.wspGiftCountdownInterval) {
    window.wspGiftCountdownInterval = window.setInterval(tick, 1000);
  }
})();